import { useBoundStore } from '@Store/index.ts';
import { OnboardingFormFields } from '@Types/index.ts';
import { setGA4UserProperties } from '@Services/analytics/analytics.service';
import type { CardShipmentAddressType } from '@Store/slices/customer/customer.types';
import type { IHomeAddressForm } from '@Types/homeAddress';

export const syncSliceWithForm = (formData: IHomeAddressForm) => {
  const { getCustomerData, setCustomerData } = useBoundStore.getState();
  const customerDataToUpdate = getCustomerData();
  setCustomerData({
    ...customerDataToUpdate,
    customerData: {
      ...customerDataToUpdate.customerData,
      mailingAddressData: {
        ...customerDataToUpdate.customerData.mailingAddressData,
        line1: formData[OnboardingFormFields.LINE1],
        line2: formData[OnboardingFormFields.APARTMENT],
        state: formData[OnboardingFormFields.STATE]?.value,
        city: formData[OnboardingFormFields.CITY],
        postalCode: formData[OnboardingFormFields.ZIP],
        country: 'US',
      },
    },
  });
  setGA4UserProperties();
};

export const syncCardShipmentToStore = (
  cardShipmentAddressType: CardShipmentAddressType,
  formData: IHomeAddressForm
) => {
  const { getCustomerData, setCustomerData } = useBoundStore.getState();
  const customerDataToUpdate = getCustomerData();
  setCustomerData({
    ...customerDataToUpdate,
    customerData: {
      ...customerDataToUpdate.customerData,
      cardShipmentAddressType,
      ...(cardShipmentAddressType === 'MAILING' && {
        mailingAddressData: {
          ...customerDataToUpdate.customerData.mailingAddressData,
          line1: formData[OnboardingFormFields.LINE1],
          line2: formData[OnboardingFormFields.APARTMENT],
          state: formData[OnboardingFormFields.STATE]?.value,
          city: formData[OnboardingFormFields.CITY],
          postalCode: formData[OnboardingFormFields.ZIP],
          country: 'US',
        },
      }),
    },
  });
};
